(() => {
  const localeRoot = window.Shopify?.routes?.root || '/';
  if (localeRoot === '/') return;

  const localePrefix = localeRoot.replace(/\/$/, '');
  const storefrontPath = /^\/(products|collections|pages|blogs|policies|search|cart)(\/|$)/;

  const localizeLink = (link) => {
    if (
      link.hasAttribute('hreflang') ||
      link.hasAttribute('data-rg-no-localize') ||
      link.closest('localization-form, .localization-form')
    ) {
      return;
    }

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || /^(mailto:|tel:|javascript:)/i.test(href)) return;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (_error) {
      return;
    }

    if (url.origin !== window.location.origin || !storefrontPath.test(url.pathname)) return;
    if (url.pathname === localePrefix || url.pathname.startsWith(`${localePrefix}/`)) return;

    link.setAttribute('href', `${localePrefix}${url.pathname}${url.search}${url.hash}`);
  };

  const localizeLinksIn = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.matches?.('a[href]')) localizeLink(root);
    root.querySelectorAll?.('a[href]').forEach(localizeLink);
  };

  const start = () => {
    localizeLinksIn(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(localizeLinksIn);
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
